<template>
  <div>
    <!-- 条件搜索 -->
    <div class="page_top">
      <div class="title_wrapper">
        <div class="dis_flex">
          <h1 class="title_from">职级管理</h1>
        </div>
        <a-button type="primary" @click="goPage('add','')" >
          新增
        </a-button>
      </div>

      <div class="search_wrapper">
        <a-form layout="inline">
          <a-form-item label="职级名称">
            <a-input v-model="queryParam.rankName" placeholder="职级名称" allow-clear />
          </a-form-item>
        </a-form>

        <a-radio-group>
          <a-button class="mr20" type="default" @click="getClearList">
            重置
          </a-button>
          <a-button class="mr20" type="primary" @click="getList">
            查询
          </a-button>
        </a-radio-group>
      </div>
    </div>

    <!-- 增加修改 -->
    <create-form
      ref="createForm"
      @ok="getList"
    />
    <!-- 数据展示 -->
    <div class="list_con">
      <div class="nodata" v-if="total <= 0">
        <no-data></no-data>
      </div>
      <div v-else>

        <a-table
          :loading="loading"
          :columns="columns"
          :data-source="list"
          :pagination="pagination"
          @change="handleChangeInTable"
          :rowKey="(item, index) => {return index } "
        >

          <template slot="sysUserVoList" slot-scope="text, item">
            <a :title="item.sysUserVoList | userNameList">
              {{ item.sysUserVoList | userNameList }}
            </a>
          </template>

          <template slot="operation" slot-scope="text, item">
            <a-button type="link" @click="goPage('edit',item.id)">编辑</a-button>
            <a-button type="link" @click="handleDelete(item)">删除</a-button>
          </template>
        </a-table>

      </div>
    </div>
  </div>
</template>

<script>

import { professionList, delProfession } from '@/api/system/profession'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Profession',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        rankName: undefined
      },
      // 分页参数
      pagination: {
        current: 1,
        pageSize: this.$getters.pageSize,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          // range[0] + '-' + range[1] +
          return ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      columns: [
        {
          title: '职级',
          align: 'center',
          dataIndex: 'rankName',
          key: '1',
          width: 120,
          scopedSlots: { customRender: 'rankName' }
        },
        {
          title: '升级（司龄-累计业绩）',
          align: 'center',
          dataIndex: 'workAge.workPerformance',
          key: '2',
          width: 240,
          customRender: (text, record, index) => `${ record.workAge + '-' + record.workPerformance }`
        },
        {
          width: 210,
          title: '降级',
          dataIndex: 'quarterlyAveragePerformance',
          key: '3',
          ellipsis: false,
          scopedSlots: { customRender: 'quarterlyAveragePerformance' }
        },
        {
          title: '人员',
          align: 'center',
          dataIndex: 'sysUserVoList',
          key: '4',
          width: '20%',
          scopedSlots: { customRender: 'sysUserVoList' }
        },
        {
          width: '10%',
          title: '操作',
          align: 'center',
          dataIndex: 'operation',
          key: '5',
          ellipsis: false,
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  filters: {
    userNameList: function (list) {
      if (!list) return ''
     const names = list.map((item) => {
       if (item) {
          return item.nickName ? item.nickName : '--'
       } else {
          return ''
       }
     })
      return names.join('、')
    }
  },
  created () {
    this.getClearList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    // 分页、排序、筛选变化时触发
    handleChangeInTable (pagination, filters, sorter) {
      this.pagination = pagination
      this.getList()
    },
    getClearList () {
      this.queryParam = {
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        rankName: undefined
      }
      this.getList()
    },
    /** 查询职级列表 */
    getList () {
      this.loading = true
      this.queryParam.pageNum = this.pagination.current
      this.queryParam.pageSize = this.pagination.pageSize
      professionList(this.queryParam).then(response => {
        if (response.code === 200) {
            const resData = response.data
            this.total = resData.total
            this.pagination.total = resData.total
            this.list = resData.records
          }
          this.loading = false
        }
      )
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
         pageNum: 1,
         pageSize: this.$getters.pageSize,
        rankName: undefined
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.postId)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const professionIds = row.id // || this.ids
      const name = row.rankName
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中职级为' + name + '的数据',
        onOk () {
          return delProfession(professionIds)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {}
      })
    },
    goPage (pageType, id) {
      this.$router.push({ path: '/profession/' + pageType, query: { dataId: id } })
    }
  }
}
</script>
<style lang="less" scoped>
@titleFontSize:20px;
@titleColor:#222;
@bodyFont:14px;
@bodyColor:#666;
@tagFont:12px;
@tagColor:#ddd;
.mr20{
  margin-right:20px;
}
.w100{
    width:100px;
}
.page_top,
.list_con{
  background:#fff;
  padding:20px;
}
.list_con{
  margin-top:10px;
}
.title_wrapper{
    display:flex;
    flex-wrap: wrap;
    width:100%;
    height:auto;
    justify-content: space-between;
}
.title_from{
    font-size:@titleFontSize;
    color:@titleColor;
    font-weight: bolder;
}
.textMore{
  overflow:hidden;
	text-overflow:ellipsis;
	white-space:nowrap
}
.cursor_pointer{
  cursor:pointer;
}
.tb_list{
    width:100%;
    height:auto;
    line-height:35px;
    text-align: center;
    color:@bodyColor ;
}

.tb_list tr th,.tb_list tr td{
  width:19%;
  display: inline-block;
  padding: 12px 8px;
  text-align:center;
}
.tb_list tr th{
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    background: #fafafa;
    border-bottom: 1px solid #e8e8e8;
    -webkit-transition: background 0.3s ease;
    transition: background 0.3s ease;
}
.tb_list tr td{
  border-bottom: 1px solid #e8e8e8;
    -webkit-transition: background 0.3s;
    transition: background 0.3s;
}

.tb_list tr th:nth-child(4),.tb_list tr td:nth-child(4){
  width:24%;
}
.tb_list tr:hover{
  background:#fcded4;
}

.search_wrapper{
  display:flex;
    flex-wrap: wrap;
    width:100%;
    height:auto;
    justify-content: flex-start;
    align-items: center;
    margin-top: 30px;
}
.item_search{
    display:flex;
    align-items: center;
    margin-right:18px;
    margin-bottom: 20px;
}
.btn{
    cursor: pointer;
    font-size:15px;
}

</style>
